// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"oc03Ngs7mp","notificationIcon":"_1q7JFu8NmC","iconBack":"_2qhbJtXjm5"};